// @flow

import * as React from 'react';
import { localize, unescaped } from '@ta/common.i18n';
import styles from './ImportantBlockUserInfo.less';

const getHelpCenterLink = () => `${localize('mobile_help_center_url')}/articles/200613547`;

const ImportantBlockUserInfo = () => (
  <React.Fragment>
    {/** TripAdvisor is a public forum to post and share content.
     Blocking a user will not disable their ability to view your public content or your public profile pages. */}
    {localize('social_block_modal_more_v2')}
    {/** TODO: Add href and target */}
    {/** <a class="{className}" target="{target}" href="{href}">Learn more</a> about what it means to block an account on TripAdvisor. */}
    {unescaped(
      localize('social_block_modal_more_hyperlink', {
        href: getHelpCenterLink(),
        className: styles.privacy,
        target: '_blank',
      }),
    )}
  </React.Fragment>
);

export default ImportantBlockUserInfo;
